import { getPlatform } from '@mc/mc-base-env/src/web/platform.js'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '@/defines/events'
import Url from '@mc/mc-utils/js/url/url'

class MiniProgramEnv {
  isWechatMiniProgram = false
  isAlipayMiniProgram = false
  isWechatMiniProgramDetected = false
  isAlipayMiniProgramDetected = false

  get isMiniProgramDetected() {
    return this.isWechatMiniProgramDetected && this.isWechatMiniProgramDetected
  }

  get isMiniProgram() {
    return this.isWechatMiniProgram || this.isAlipayMiniProgram
  }
}

export const miniProgramEnv = new MiniProgramEnv()

export const detectWechatMiniProgram = () => {
  return new Promise(resolve => {
    if (miniProgramEnv.isWechatMiniProgramDetected) {
      resolve(miniProgramEnv.isWechatMiniProgram)
    } else {
      const ua = navigator.userAgent.toLowerCase()
      if (/miniProgram/i.test(ua) && !/alipayclient/i.test(ua)) {
        // 1、通过ua是否含miniprogram，判断小程序环境
        miniProgramEnv.isWechatMiniProgram = true
        miniProgramEnv.isWechatMiniProgramDetected = true
        resolve(true)
      } else if (getPlatform() === 'wechat') {
        const timeout = setTimeout(() => {
          resolve(false)
        }, 1000) // 等下面这个 ready 最多 1s 钟，否则放弃判断，别卡住。
        if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            () => {
              clearTimeout(timeout)
              // 2、通过监听WeixinJSBridgeReady，window.__wxjs_environment变量判断小程序环境
              const env =
                window.__wxjs_environment === 'miniprogram' ? 'wxmp' : 'wx'
              if (env === 'wxmp') {
                miniProgramEnv.isWechatMiniProgram = true
                miniProgramEnv.isWechatMiniProgramDetected = true
                resolve(true)
              } else {
                miniProgramEnv.isWechatMiniProgramDetected = true
                resolve(false)
              }
            },
            false
          )
        } else {
          return window.wx.miniProgram.getEnv(res => {
            // 3、通过js-sdk的wx.miniProgram.getEnv方法，判断小程序环境
            if (res.miniprogram) {
              miniProgramEnv.isWechatMiniProgram = true
              miniProgramEnv.isWechatMiniProgramDetected = true
              resolve(true)
            } else {
              miniProgramEnv.isWechatMiniProgramDetected = true
              resolve(false)
            }
          })
        }
      } else {
        miniProgramEnv.isWechatMiniProgramDetected = true
        resolve(false)
      }
    }
  })
}

export const detectAlipayMiniProgram = () => {
  return new Promise(resolve => {
    if (miniProgramEnv.isAlipayMiniProgramDetected) {
      resolve(miniProgramEnv.isAlipayMiniProgram)
    } else {
      if (window.my) {
        window.my.getEnv(res => {
          const url = new Url(window.location.href)
          const query = url.parseQuerystring()
          const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
          const appVersion = query.app_version || hashQuery.app_version || ''
          if (res.miniprogram && appVersion) {
            miniProgramEnv.isAlipayMiniProgram = true
            miniProgramEnv.isWechatMiniProgramDetected = true
            resolve(true)
          } else {
            miniProgramEnv.isWechatMiniProgramDetected = true
            resolve(false)
          }
        })
      } else {
        miniProgramEnv.isWechatMiniProgramDetected = true
        resolve(false)
      }
    }
  })
}

export const detectMiniProgram = async () => {
  if (miniProgramEnv.isMiniProgramDetected) {
    return Promise.resolve([
      miniProgramEnv.isWechatMiniProgram,
      miniProgramEnv.isAlipayMiniProgram
    ])
  } else {
    const res = await Promise.all([
      detectWechatMiniProgram(),
      detectAlipayMiniProgram()
    ])
    eventbus.dispatch(EventNames.miniProgramDetected)
    return res
  }
}
